module.exports = __webpack_public_path__ + "img/active-20.8d306873.svg";